import { getCurrencySymbol } from './currencyConverter';

/**
 * Formats a price number into a standardized format with bold main amount
 * Backend handles all currency conversion - this function only formats already-converted prices
 * @param {number} price - The price to format (already in target currency)
 * @param {boolean} [asHtml=true] - Whether to return HTML with bold tags or plain text
 * @param {string} [currency=''] - Currency symbol to append (optional, overrides displayCurrency)
 * @param {string} [displayCurrency='SEK'] - Currency to get symbol for
 * @param {boolean} [showCurrency=true] - Whether to show currency symbol
 * @returns {string} Formatted price string
 */
export const formatPrice = (price, asHtml = true, currency = '', displayCurrency = 'SEK', showCurrency = true) => {
  if (price == null || isNaN(price)) {
    const formatted = asHtml ? '<strong>0</strong>.00' : '0.00';
    if (!showCurrency) {
      return formatted;
    }
    const currencySymbol = currency || getCurrencySymbol(displayCurrency);
    return `${formatted} ${currencySymbol}`;
  }

  // Format the price with thousands separators and 2 decimal places
  const [wholePart, decimalPart = '00'] = price.toFixed(2).split('.');
  const formattedWhole = wholePart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  
  let formatted;
  if (asHtml) {
    formatted = `<strong>${formattedWhole}</strong>.${decimalPart}`;
  } else {
    formatted = `${formattedWhole}.${decimalPart}`;
  }
  
  if (!showCurrency) {
    return formatted;
  }
  
  const currencySymbol = currency || getCurrencySymbol(displayCurrency);
  return `${formatted} ${currencySymbol}`;
};

/**
 * Vue plugin for price formatting (Vue 3 compatible)
 * Usage in template: {{ $formatPrice(price) }}
 */
export const priceFilter = {
  install(app) {
    app.config.globalProperties.$formatPrice = (price, currency = '') => formatPrice(price, false, currency);
  }
}; 